import clienteAxios from './clienteAxios';

// Evento para que el menú lateral y la página de notificaciones se mantengan
// sincronizados: quien cambia algo (leer, limpiar) avisa y el otro vuelve a pedir.
export const EVENTO_NOTIFICACIONES = 'notificaciones:actualizar';
export const avisarCambioNotificaciones = () =>
  window.dispatchEvent(new Event(EVENTO_NOTIFICACIONES));

export const obtenerResumen = () => clienteAxios.get('/notificaciones').then((r) => r.data);
export const obtenerLista = (page, perPage = 15) =>
  clienteAxios
    .get('/notificaciones/lista', { params: { page, per_page: perPage } })
    .then((r) => r.data);
export const marcarLeida = (id) => clienteAxios.post(`/notificaciones/${id}/leer`);
export const marcarTodasLeidas = () => clienteAxios.post('/notificaciones/leer-todas');
export const limpiarNotificaciones = () => clienteAxios.delete('/notificaciones');

const formatoRelativo = new Intl.RelativeTimeFormat('es', { numeric: 'auto' });

export const tiempoRelativo = (iso) => {
  if (!iso) return '';
  const segundos = Math.round((new Date(iso).getTime() - Date.now()) / 1000);
  const abs = Math.abs(segundos);
  if (abs < 60) return 'justo ahora';
  if (abs < 3600) return formatoRelativo.format(Math.round(segundos / 60), 'minute');
  if (abs < 86400) return formatoRelativo.format(Math.round(segundos / 3600), 'hour');
  if (abs < 86400 * 30) return formatoRelativo.format(Math.round(segundos / 86400), 'day');
  return new Date(iso).toLocaleDateString('es-MX', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
};

// Separa lo que la persona debe atender de lo informativo, conservando el orden.
export const agruparNotificaciones = (items) => [
  { clave: 'action', titulo: 'Por atender', items: items.filter((n) => n.category === 'action') },
  {
    clave: 'update',
    titulo: 'Actualizaciones',
    items: items.filter((n) => n.category !== 'action')
  }
];
